// extracted by mini-css-extract-plugin
export var contrastLow = "_f-1";
export var externalLink = "_f-2";
export var externalLinkIcon = "_f-3";
export var link = "_f-0";
export var linkLabel = "_f-4";